import * as R from 'remeda'

export const countryMap = {
  albania: 'Albania',
  algeria: 'Algeria',
  argentina: 'Argentina',
  armenia: 'Armenia',
  australia: 'Australia',
  austria: 'Austria',
  azerbaijan: 'Azerbaijan',
  belarus: 'Belarus',
  belgium: 'Belgium',
  bosnia_and_herzegovina: 'Bosnia and Herzegovina',
  brazil: 'Brazil',
  bulgaria: 'Bulgaria',
  canada: 'Canada',
  chile: 'Chile',
  china: 'China',
  colombia: 'Colombia',
  costa_rica: 'Costa Rica',
  croatia: 'Croatia',
  cyprus: 'Cyprus',
  czechia: 'Czechia',
  denmark: 'Denmark',
  egypt: 'Egypt',
  estonia: 'Estonia',
  finland: 'Finland',
  france: 'France',
  georgia: 'Georgia',
  germany: 'Germany',
  greece: 'Greece',
  greenland: 'Greenland',
  hong_kong: 'Hong Kong',
  hungary: 'Hungary',
  iceland: 'Iceland',
  india: 'India',
  indonesia: 'Indonesia',
  iran: 'Iran',
  iraq: 'Iraq',
  ireland: 'Ireland',
  israel: 'Israel',
  italy: 'Italy',
  japan: 'Japan',
  korea: 'Korea',
  kazakhstan: 'Kazakhstan',
  latvia: 'Latvia',
  lebanon: 'Lebanon',
  liechtenstein: 'Liechtenstein',
  lithuania: 'Lithuania',
  luxembourg: 'Luxembourg',
  malta: 'Malta',
  mexico: 'Mexico',
  moldova: 'Moldova',
  monaco: 'Monaco',
  montenegro: 'Montenegro',
  netherlands: 'Netherlands',
  new_zealand: 'New Zealand',
  norway: 'Norway',
  other: 'Other',
  paraguay: 'Paraguay',
  peru: 'Peru',
  poland: 'Poland',
  portugal: 'Portugal',
  romania: 'Romania',
  russia: 'Russia',
  saudi_arabia: 'Saudi Arabia',
  serbia: 'Serbia',
  singapore: 'Singapore',
  slovakia: 'Slovakia',
  slovenia: 'Slovenia',
  south_africa: 'South Africa',
  spain: 'Spain',
  sweden: 'Sweden',
  switzerland: 'Switzerland',
  taiwan: 'Taiwan',
  thailand: 'Thailand',
  turkey: 'Turkey',
  ukraine: 'Ukraine',
  united_arab_emirates: 'United Arab Emirates',
  united_kingdom: 'United Kingdom',
  united_states_of_america: 'United States of America',
  uruguay: 'Uruguay',
  venezuela: 'Venezuela',
  viet_nam: 'Viet Nam',
} as const

export const countryList = R.values(countryMap)
